import {create} from "zustand";

type CatalogFiltersStore = {
    filtersDrawerFlag: boolean;
    openFiltersDrawer: () => void;
    closeFiltersDrawer: () => void;
};

export const useCatalogFilters = create<CatalogFiltersStore>((set) => ({
    filtersDrawerFlag: false,

    openFiltersDrawer: () => set({filtersDrawerFlag: true}),

    closeFiltersDrawer: () => set({filtersDrawerFlag: false}),
}));
